import React, { useEffect, useState } from "react";
import { useMediaQuery } from 'react-responsive';
import { Link } from "react-router-dom";
import { Table, Card } from "react-bootstrap";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./MerchantOverview.css";
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';

const MerchantOverview = () => {
  const [loading, setLoading] = useState(true);
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const [inputs, setInputs] = useState({ total_sales: 0, total_subscribed: 0, total_subscribed_free: 0, total_subscribed_quit: 0, total_free_charge: 0 });

  const [merchants, setMerchants] = useState([]);

  const [links, setLinks] = useState([]);
  const [keyword, setKeyword] = useState('');

  const [sortOrder, setSortOrder] = useState("asc");

  const [perpage, setPerpage] = useState(10);

  const [totalrec, setTotalrec] = useState(0);

  useEffect(() => {
    document.title = `MerchantOverview | bluefaucet`;
    document.getElementById("bodywrap").className = "dashchant";

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('per_page', 10);
    formData.append('page', 1);
    formData.append('order_by', 'asc');
    API.post('backoffice_all_merchants', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setInputs({
            total_sales: response.data.data.total_sales,
            total_subscribed: response.data.data.total_subscribed,
            total_subscribed_free: response.data.data.total_subscribed_free,
            total_subscribed_quit: response.data.data.total_subscribed_quit,
            total_free_charge: response.data.data.total_free_charge
          });
          setMerchants(response.data.data.merchants.data);
          setLinks(response.data.data.merchants.links);
          setTotalrec(response.data.data.merchants.total);
        }
      }).catch(error => {
        setLoading(false);

      });

  }, []);


  const handleSort = () => {
    setLoading(true);
    var ascdesc = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(ascdesc);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('per_page', perpage);
    formData.append('page', 1);
    formData.append('order_by', ascdesc);
    formData.append('keyword', keyword);
    API.post('backoffice_all_merchants', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchants(response.data.data.merchants.data);
          setLinks(response.data.data.merchants.links);
          setTotalrec(response.data.data.merchants.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };
  const handleRowsChange = (e) => {
    setLoading(true);
    var perpage = parseInt(e.target.value);
    setPerpage(perpage);

    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('per_page', perpage);
    formData.append('page', 1);
    formData.append('order_by', sortOrder);
    formData.append('keyword', keyword);
    API.post('backoffice_all_merchants', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchants(response.data.data.merchants.data);
          setLinks(response.data.data.merchants.links);
          setTotalrec(response.data.data.merchants.total);
        }
      }).catch(error => {
        setLoading(false);
      });

  };

  const handleInputChangeauto = (event) => {
    var keyword = event.target.value;
    setKeyword(keyword);
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('per_page', perpage);
    formData.append('page', 1);
    formData.append('order_by', sortOrder);
    formData.append('keyword', keyword);
    API.post('backoffice_all_merchants', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchants(response.data.data.merchants.data);
          setLinks(response.data.data.merchants.links);
          setTotalrec(response.data.data.merchants.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  }

  const handlePageChange = (page) => {
    let formData = new FormData();
    formData.append('token', localStorage.getItem("token"));
    formData.append('per_page', perpage);
    formData.append('page', page);
    formData.append('order_by', sortOrder);
    formData.append('keyword', keyword);
    API.post('backoffice_all_merchants', formData)
      .then(response => {
        if (response.data.status === 0) {
          setLoading(false);
        } else {
          setLoading(false);
          setMerchants(response.data.data.merchants.data);
          setLinks(response.data.data.merchants.links);
          setTotalrec(response.data.data.merchants.total);
        }
      }).catch(error => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-12 d-flex align-items-center justify-content-between mb-3 firsty">
                    <h5>Statistics</h5>
                  </div>

                  <div className="col-12 mb-4">
                    <div className="row">
                      <div key={1} className="custom-box-item">
                        <div className="ov-box d-flex align-items-center">
                          <div className="d-flex align-items-center justify-content-center me-2">
                            <img
                              src={process.env.REACT_APP_BASE_URL + 'assests/images/c-1.png'}
                              alt='Paid Merchants'
                            />
                          </div>
                          <div>
                            <div className="count">{inputs.total_subscribed}</div>
                            <div className="name">Paid Merchants</div>
                          </div>
                        </div>
                      </div>
                      <div key={2} className="custom-box-item">
                        <div className="ov-box d-flex align-items-center">
                          <div className="d-flex align-items-center justify-content-center me-2">
                            <img
                              src={process.env.REACT_APP_BASE_URL + 'assests/images/c-2.png'}
                              alt='Quit Merchants'
                            />
                          </div>
                          <div>
                            <div className="count">{inputs.total_subscribed_quit}</div>
                            <div className="name">Quit Merchants</div>
                          </div>
                        </div>
                      </div>
                      <div key={22} className="custom-box-item">
                        <div className="ov-box d-flex align-items-center">
                          <div className="d-flex align-items-center justify-content-center me-2">
                            <img
                              src={process.env.REACT_APP_BASE_URL + 'assests/images/ft-2.png'}
                              alt='FREE Charge'
                            />
                          </div>
                          <div>
                            <div className="count">{inputs.total_free_charge}</div>
                            <div className="name">Free Charge</div>
                          </div>
                        </div>
                      </div>
                      <div key={3} className="custom-box-item">
                        <div className="ov-box d-flex align-items-center">
                          <div className="d-flex align-items-center justify-content-center me-2">
                            <img
                              src={process.env.REACT_APP_BASE_URL + 'assests/images/c-3.png'}
                              alt='Free Trial Merchants'
                            />
                          </div>
                          <div>
                            <div className="count">{inputs.total_subscribed_free}</div>
                            <div className="name">Free Trial Merchants</div>
                          </div>
                        </div>
                      </div>
                      <div key={4} className="custom-box-item last">
                        <div className="ov-box d-flex align-items-center">
                          <div className="d-flex align-items-center justify-content-center me-2">
                            <img
                              src={process.env.REACT_APP_BASE_URL + 'assests/images/c-4.png'}
                              alt='Salesperson Number'
                            />
                          </div>
                          <div>
                            <div className="count">{inputs.total_sales}</div>
                            <div className="name">Salesperson Number</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 holisti hoki">
                    <Card className="h-100">
                      <div className="d-flex flex-column-reverse flex-md-row justify-content-between align-items-md-center">
                        <h5 className="mb-2 mb-md-0 pogha">List of Merchants Information</h5>
                        <div className="d-flex align-items-center gap-3 mb-2 mb-lg-0">
                          <div className="d-flex align-items-center w-100 justify-content-md-start w-md-auto">
                            <div className="flex-grow-1 ms-lg-3 ms-0 me-2">
                              <div className="input-group">
                                <div className="input-group-text border-end-0">
                                  <img
                                    src={process.env.REACT_APP_BASE_URL + 'assests/images/se-2.png'}
                                    alt="Search Icon"
                                    className="img-fluid"
                                  />
                                </div>
                                <input
                                  type="text"
                                  className="form-control border-start-0 ps-0"
                                  placeholder="Search"
                                  value={keyword}
                                  onChange={handleInputChangeauto}
                                />
                              </div>
                            </div>
                            <button type="button" className="sloti" onClick={handleSort}>
                              <img src={process.env.REACT_APP_BASE_URL + 'assests/images/sort.png'} alt="Sort" className="img-fluid me-2" />
                              Sort {sortOrder === "asc" ? "(A-Z)" : "(Z-A)"}
                            </button>
                          </div>
                        </div>
                      </div>
                      {isMobile ? (
                        <div className="mobile-cards">
                          {merchants.map((item, idx) => (
                            <div key={idx} className="mobile-card">
                              <div className="d-flex justify-content-between mb-3">
                                <div className="joily d-flex">
                                  <div className="date">{item.join_date} -</div> Join Date
                                </div>
                                <div className={`badge `}>{item.membership}</div>
                              </div>
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div className="stoling d-flex align-items-center"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/homly.png'} alt="" className="img-fluid" /><Link to={process.env.REACT_APP_BASE_URL + 'merchant-subscription/' + item.id} className="table-link">{item.store_name}</Link></div>
                                <div className="income">${parseFloat(item.total_revenue.replace('$', '')).toFixed(2)}</div>
                              </div>
                              <div className="row ijh mb-2">
                                <div className="col-4">
                                  <h2>Merchat ID:</h2>
                                  <h3>{item.merchant_id}</h3>
                                </div>
                                <div className="col-4">
                                  <h2>Salesperson:</h2>
                                  <h3>
                                    {parseInt(localStorage.getItem("department")) === 2 || parseInt(localStorage.getItem("department")) === 3 || parseInt(localStorage.getItem("department")) === 7 ? (
                                      item.salesperson ? <Link to={process.env.REACT_APP_BASE_URL + 'salesperson-information/' + item.sales_id}>{item.salesperson}</Link> : "-"
                                    ) : (
                                      item.salesperson ? <Link to={process.env.REACT_APP_BASE_URL + ''} >{item.salesperson}</Link> : "-"
                                    )}
                                  </h3>
                                </div>
                                <div className="col-4">
                                  <h2>Subcategory:</h2>
                                  <h3>{item.subcategory}</h3>
                                </div>
                              </div>

                              <div className="details d-flex justify-content-between align-items-center">
                                <div className="avatar-group">
                                  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar1.png'} alt="avatar" className="avatar-img" />
                                  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar2.png'} alt="avatar" className="avatar-img" />
                                  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar3.png'} alt="avatar" className="avatar-img" />
                                  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar4.png'} alt="avatar" className="avatar-img" />
                                  <img src={process.env.REACT_APP_BASE_URL + 'assests/images/avatar5.png'} alt="avatar" className="avatar-img" />
                                  <div className="avatar-extra">+418</div>
                                </div>
                                <div><img src={process.env.REACT_APP_BASE_URL + 'assests/images/location.png'} alt="" className="img-fluid loco" />{item.location}</div>
                              </div>

                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="table-ro">
                          <div style={{ overflowY: "auto" }}>
                            <Table responsive className="table-no-last-border mb-0">
                              <thead className="table">
                                <tr className="custom-header">
                                  <th className="lft">Join Date</th>
                                  <th>Merchat ID</th>
                                  <th>Store Name</th>
                                  <th>Location</th>
                                  <th>Membership</th>
                                  <th>Customers</th>
                                  <th>Subcategory</th>
                                  <th>Salesperson</th>
                                  <th>Revenue</th>
                                </tr>
                              </thead>
                              <tbody>
                                {merchants.map((item, idx) => (
                                  <tr key={idx}>
                                    <td className="lef">{item.join_date}</td>
                                    <td>{item.merchant_id}</td>
                                    <td><Link to={process.env.REACT_APP_BASE_URL + 'merchant-subscription/' + item.id} className="table-link">{item.store_name}</Link></td>
                                    <td>{item.location}</td>
                                    <td>{item.membership}</td>
                                    <td>{item.customers}</td>
                                    <td>{item.subcategory}</td>
                                    <td>
                                      {parseInt(localStorage.getItem("department")) === 2 || parseInt(localStorage.getItem("department")) === 3 || parseInt(localStorage.getItem("department")) === 7 ? (
                                        item.salesperson ? <Link to={process.env.REACT_APP_BASE_URL + 'salesperson-information/' + item.sales_id}>{item.salesperson}</Link> : "-"
                                      ) : (
                                        item.salesperson ? <Link to={process.env.REACT_APP_BASE_URL + ''} className="table-link">{item.salesperson}</Link> : "-"
                                      )}
                                    </td>
                                    <td className="ref">${item.total_revenue}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      )}
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-2 nation gap-2">
                        <div className="d-flex align-items-center gap-2 mb-2 mb-md-0 mobile-flex">
                          <label>Show rows:</label>
                          <select
                            value={perpage}
                            onChange={handleRowsChange}
                            className="form-select w-auto"
                          >
                            <option value={10}>10 items</option>
                            <option value={15}>15 items</option>
                            <option value={20}>20 items</option>
                            <option value={25}>25 items</option>
                          </select>
                        </div>
                        {totalrec > 0 && (
                          <nav>
                            <ul className="pagination pagination-sm mb-0">

                              {links.map((link, index) => {
                                var label = link.label;
                                if (label.includes("Previous")) label = "<";
                                if (label.includes("Next")) label = ">";

                                return (
                                  <>
                                    <li className={`page-item ${link.active ? "active" : ""}`}>
                                      <button
                                        className={`page-link ${!link.url ? "disabled" : ""}`}
                                        onClick={() => {
                                          if (link.url) {
                                            const pageNumber = new URLSearchParams(link.url.split("?")[1]).get("page");
                                            handlePageChange(pageNumber);
                                          }
                                        }}

                                      >
                                        {label}
                                      </button>
                                    </li>
                                  </>
                                );
                              })}
                            </ul>
                          </nav>
                        )}
                      </div>
                    </Card>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
    </>
  );
};
export default MerchantOverview;